module.exports = __webpack_public_path__ + "777058c57ca9c5575125ceb01ae948b5.svg";